import React from "react";
import logo from "../../assets/images/80eight/88-blue.svg";
import blockedAccount from "../../assets/icons/cross.svg";

export default function BlockedAccount() {
  const handleContact = () => {
    window.open("mailto:support@80eight.io", "_self");
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="w-full h-[112px] px-[80px] flex items-center md:justify-start justify-center border-b border-[#EBE9EF]">
        <img src={logo} alt="80eight" className="h-[32px] w-auto" />
      </div>

      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-120px)] max-w-[528px] mx-auto px-4">
        <div className="relative mb-8">
          <img
            src={blockedAccount}
            alt="blocked account"
            className="w-[92px] h-[92px]"
          />
        </div>

        <div className="max-w-[358px] mx-auto text-center px-[5px]">
          <h1 className="text-[32px] font-semibold text-[#57249C] mb-4 text-center font-plusjakarta">
            Your account has been blocked
          </h1>

          <p className="text-[#423E51] mb-8 text-[16px] font-plusjakarta leading-relaxed">
            If we have not already contacted you, please reach out to{" "}
            <a
              href="mailto:support@80eight.io"
              className="text-[#57249C] underline"
            >
              support@80eight.io
            </a>{" "}
            <br />
            as soon as possible so we can assist with resolving this issue.
          </p>
        </div>

        <button
          onClick={handleContact}
          className="w-full h-[64px] bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white px-6 py-4 text-[20px] font-semibold rounded-full hover:opacity-90 transition-opacity disabled:cursor-not-allowed"
        >
          Contact
        </button>
      </div>
    </div>
  );
}
